import { render, staticRenderFns } from "./AdminAnnualLeaveApproveForm.vue?vue&type=template&id=a3fb956a&"
import script from "./AdminAnnualLeaveApproveForm.vue?vue&type=script&lang=js&"
export * from "./AdminAnnualLeaveApproveForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminAnnualLeaveApproveForm.vue?vue&type=style&index=0&id=a3fb956a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports